import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { loaderImg, noImageIcon } from "../images";
import { isTMA } from "../constants";

const heightObj = {
  carousel: "190px",
  "dynamic-banner": isTMA() ? "170px" : "230px",
  "banner-tile": "350px",
};

function CommonVideoImageComponent({
  isVideo,
  thumbnail_url,
  asset_url,
  imgSrc = "",
  setImgSrc,
  isFrom = "",
}) {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [mainImageSrc, setMainImageSrc] = useState(asset_url || loaderImg);

  const isDynamicBanner = isFrom === "dynamic-banner";

  useEffect(() => {
    setMainImageSrc(asset_url || loaderImg);
  }, [asset_url]);

  const renderBannerImage = () => {
    const logoProps = {
      src: imgSrc || loaderImg,
      height: "54px",
      width: "54px",
      alt: "logo",
      className: "dynamic-banner-logo-image",
      onError: () => setImgSrc?.(loaderImg),
    };
    if (asset_url) {
      return (
        <>
          <img
            src={mainImageSrc}
            alt="banner"
            height={heightObj[isFrom] || "250px"}
            width="100%"
            style={{ borderRadius: "14px", objectFit: "cover" }}
            onError={(e) => {
              e.currentTarget.onerror = null; // prevent loops
              setMainImageSrc(loaderImg);
            }}
          />
          {isDynamicBanner && <img {...logoProps} />}
        </>
      );
    }

    return (
      <Box className="no-image" height={heightObj[isFrom]}>
        {isDynamicBanner ? (
          <img {...logoProps} />
        ) : (
          <img
            src={noImageIcon}
            height="54px"
            width="54px"
            className="image-icon"
            alt="logo"
            onError={() => setImgSrc?.(loaderImg)}
          />
        )}
      </Box>
    );
  };

  return isVideo ? (
    <Box className="video-content">
      {!videoLoaded && (
        <img
          src={thumbnail_url}
          alt="thumbnail"
          height={heightObj[isFrom] || "250px"}
          width="100%"
          style={{ borderRadius: "14px", objectFit: "cover" }}
        />
      )}
      <video
        src={asset_url}
        style={{
          display: videoLoaded ? "block" : "none",
          width: "100%",
          borderRadius: "14px",
          objectFit: "cover",
          height: heightObj[isFrom] || "250px",
        }}
        autoPlay
        muted
        onLoadedData={() => setVideoLoaded(true)}
        poster={thumbnail_url}
        playsInline
      />
      {isDynamicBanner && (
        <img
          src={imgSrc || loaderImg}
          height="54px"
          width="54px"
          className="video-icon"
          alt="logo"
          onError={() => setImgSrc?.(loaderImg)}
          style={{ objectFit: "cover" }}
        />
      )}
    </Box>
  ) : (
    renderBannerImage()
  );
}

export default CommonVideoImageComponent;
